const CandidateMilitaryServiceStatus = {
  Exempted: "EXEMPTED",
  ExpirationTermOfService: "EXPIRATION_TERM_OF_SERVICE",
  InProgressTermOfService: "IN_PROGRESS_TERM_OF_SERVICE",
  Unfulfilled: "UNFULFILLED"
};

export { CandidateMilitaryServiceStatus };
//# sourceMappingURL=candidate-military-service-status.mjs.map
